import { LoaderCircle } from 'lucide-react';
import { useCallback, useState } from 'react';

import { LogsFilters } from './components/LogsFilters';
import { LogsTable } from './components/LogsTable';

import { PaginationV2 } from '@/components/PaginationV2';
import { Card } from '@/components/ui/Card';
import { useGetAuditLogs } from '@/hooks/useGetAuditLogs';

export function AdminAuditLogs() {
  const [action, setAction] = useState<string>('0');
  const [customerId, setCustomerId] = useState<string>('0');
  const [perPage, setPerPage] = useState(20);

  const onPerPage = useCallback((value: number) => {
    setPerPage(value);
  }, []);

  const { filteredLogs, isLoading, pagination } = useGetAuditLogs({
    customer: customerId !== '0' ? parseInt(customerId, 10) : undefined,
    action: action !== '0' ? action : undefined,
    limit: perPage,
  });

  return (
    <div
      className="mb-6 flex flex-col space-y-6"
      style={{ minHeight: '100vh' }}
    >
      <h1 className="text-4xl font-bold">Audit Logs</h1>

      <Card className="mb-6 bg-white p-4">
        <LogsFilters
          action={action}
          customerId={customerId}
          perPage={perPage}
          onActionChange={setAction}
          onCustomerChange={setCustomerId}
          onPerPage={onPerPage}
        />

        {filteredLogs.length === 0 && !isLoading && (
          <div className="py-10 text-center text-gray-500">
            No audit logs found.
          </div>
        )}

        {isLoading && <LoaderCircle className="mx-auto mt-10 animate-spin" />}

        {!isLoading && filteredLogs.length > 0 && (
          <LogsTable filteredLogs={filteredLogs} />
        )}

        {!isLoading && (
          <PaginationV2
            className="mt-6"
            hasNextPage={pagination.hasNextPage}
            hasPreviousPage={pagination.hasPreviousPage}
            nextPage={pagination.nextPage}
            previousPage={pagination.previousPage}
            page={pagination.currentPage}
            totalPages={pagination.totalPages}
          />
        )}
      </Card>
    </div>
  );
}
